import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { RenderInputWithDiv, RenderNumberInput, RenderSelect } from '../../../component/formInput';

var _ = require("lodash");

class DCServerModal extends React.Component {
  constructor(props) {
      super(props);
      this.state = {

      }

  }

  componentDidMount() {
    const { dcServerObj, loadDcServerAsync } = this.props;
    if(dcServerObj) {
      loadDcServerAsync(dcServerObj.id);
    }
    this.getIsFreeIpList();
  }

  componentWillUnmount() {
    const { clearDcServerDataValue } = this.props;
    clearDcServerDataValue();
  }

  // Lấy đúng danh sách IP
  getIsFreeIpList = () => {
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/is_free_ip/list',
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        const option_result = _.map(response.data.data, (i) => (
          {value: i.ip, label: i.ip}
        ))
        self.setState({
          ip_address_option: option_result
        })
      }
    });
  }
  
  submit = (values) => {
    const { onHide, invoice_code, dcServerObj, destroy } = this.props;
    let api_type = "/admin/api/dc_server/create";
    let attrs = {
      ...values
    }

    // Trường hợp update
    if(dcServerObj && dcServerObj.id) {
      api_type = "/admin/api/dc_server/update";
      attrs.id = dcServerObj.id;
    }
    return axios({
      method: 'post',
      url: window.api_url + api_type,
      data: attrs,
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        onHide();
        destroy();
      }else {
        throw new SubmissionError(response.data.error);
      }
    })
  }
  
  render() {
    const { handleSubmit, submitting, onHide, dcServerObj } = this.props;
    const { ip_address_option } = this.state;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    const title = dcServerObj ? "Chỉnh sửa" : "Thêm mới"
    const newModal = <div style={{ width: '30%' }}>
    <Modal
      {...modalConfig}
      aria-labelledby="contained-modal-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-sm"><center>{title}</center> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form-horizontal" role="form" onSubmit={handleSubmit(this.submit)}>
          <Field name="server_name" label="Tên Server" placeholder="Vui lòng nhập..." component={RenderInputWithDiv}></Field>
          <Field name="server_core" label="Server Core" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <Field name="vcore" label="V-Core" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <Field name="server_ram" label="Server Ram" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <Field name="vram" label="V Ram" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <Field name="server_hdd" label="Server HDD" placeholder="Vui lòng nhập..." component={RenderNumberInput}></Field>
          <Field name="dc_u" label="Mã U Tủ Rack" placeholder="Vui lòng nhập..." component={RenderInputWithDiv}></Field>
          <Field name="ip_address" label="IP" options={ip_address_option} component={RenderSelect}></Field>
          <div className="text-right">
            <a onClick={()=>onHide()} className={"btn"}>
              Đóng
            </a>
            <button type="submit" className={"btn bg-blue btn-primary " + (submitting ? "disabled" : "")}>
              Lưu <i className="icon-arrow-right14 position-right"></i>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
    </div>
    return newModal;
  }
};
  
const mapState = (state, props) => ({
  initialValues: {
    ...state.dcServer.data
  },
});

const mapDispatch = dispatch => ({
  loadDcServerAsync: (dc_server_id) => dispatch.dcServer.loadDcServerAsync(dc_server_id),
  clearDcServerDataValue: () => dispatch.dcServer.clearDcServerDataValue()
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'DCServerModal',
    destroyOnUnmount: true,
    enableReinitialize: true
  })(withRouter(DCServerModal))));
